import { all, fork, takeLatest } from 'redux-saga/effects';
import { CLOSE_TOAST_ALERT, SHOW_TOAST_ALERT } from '../app';
import { toast } from 'react-toastify';

function* loadRouteData() {
  yield takeLatest(SHOW_TOAST_ALERT, function (action) {
    toast[action.payload.type](action.payload.message);
  });
  yield takeLatest(CLOSE_TOAST_ALERT, function* () {});
}

export default function* notificationSaga() {
  yield all([fork(loadRouteData)]);
}
